
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './MinPasswordLength.css';
import Service from '../services/MeetingService';
import { setCustomerSettingInfo } from "./Login";

export default class MinPasswordLength extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customer_settings: null,
            customerDataLoaded: false,
            // 画面表示用の入力値
            min_password_length: '',
            // エラーメッセージ（空文字なら非表示）
            error: ''
        };
    }

    componentDidMount() {
        this.props.handlers.showProgress();
        this.getCustomerSettings();
        this.getCustomerData();
    }

    tryHideProgress() {
        if (this.state.customer_settings === null) {
            return;
        }
        if (this.state.customerDataLoaded === false) {
            return;
        }
        this.props.handlers.hideProgress();
    }

    getCustomerData() {
        const service = new Service();
        service.customer()
            .subscribe(
                customer => {
                    this.setState({
                        customerDataLoaded: true,
                        min_password_length: (customer && customer.min_password_length != null)
                            ? String(customer.min_password_length)
                            : this.state.min_password_length
                    });
                    this.tryHideProgress();
                },
                error => {
                    console.log(error);
                    this.props.handlers.hideProgress();
                    this.props.handlers.error(error);
                }
            );
    }

    getCustomerSettings() {
        const service = new Service();
        service.customerSettings()
            .subscribe(
                payload => {
                    this.setState({
                        customer_settings: payload,
                        // 既存設定がある場合に初期値へ反映
                        // ※ API のキー名が違う場合はここを合わせてください
                        min_password_length:
                            (payload && payload.min_password_length != null)
                                ? String(payload.min_password_length)
                                : ''
                    });
                    this.tryHideProgress();
                },
                error => {
                    console.log(error);
                    this.props.handlers.hideProgress();
                    this.props.handlers.error(error);
                }
            );
    }

    // 入力フィルタ：全角数字→半角、非数字は除去
    handleInput(e) {
        const raw = e.target.value;

        // 全角数字を半角へ
        const zenkakuToHankaku = raw.replace(/[０-９]/g, (s) =>
            String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
        );

        // 半角数字以外を除去
        const digitsOnly = zenkakuToHankaku.replace(/\D/g, '');

        this.setState((prev) => ({
            min_password_length: digitsOnly,
            // 入力中に一旦エラーを消す
            error: prev.error && digitsOnly.trim().length > 0 ? '' : prev.error
        }));
    }

    validate() {
        const { min_password_length } = this.state;
        if (min_password_length.trim().length === 0) {
            this.setState({ error: '※半角数値で入力してください。' });
            return false;
        }

        const lengthNum = Number(min_password_length);
        if (lengthNum < 6) {
            this.setState({ error: '※最低パスワード文字数は6以上に設定してください。' });
            return false;
        }

        return true;
    }

    submit() {
        if (!this.validate()) {
            return;
        }

        const form = new FormData();
        // ★ API の期待キーに合わせて変更してください
        form.append('min_password_length', this.state.min_password_length);
        console.log('min_password_length =', form.get('min_password_length'));
        const service = new Service();
        this.props.handlers.showProgress();

        //noinspection JSUnusedLocalSymbols
        service.updateMinPasswordLengthSetting(form).subscribe(
            payload => {
                setCustomerSettingInfo(payload);
                this.props.handlers.hideProgress();
            },
            error => {
                console.log(error);
                this.props.handlers.hideProgress();
                this.props.handlers.error(error);
            }
        );
    }

    details() {
        if (!this.state.customer_settings) {
            return (<div />);
        }

        const { min_password_length, error } = this.state;

        return (
            <div>
                <div className="body">
                    <table>
                        <tbody>
                        <tr className="score-row">
                            <td className="title">最低パスワード文字数</td>
                            <td className="desc">
                                最低パスワード文字数を設定します。<br />
                                半角数字のみ入力可能となります。
                            </td>
                            <td className="score">
                                <div style={{ marginTop: '10px', maxWidth: '240px' }}>
                                    <input
                                        id="minLength"
                                        type="text"           // 全角対応のため text + フィルタで制御
                                        inputMode="numeric"   // モバイルで数字キーボードのヒント
                                        pattern="[0-9]*"      // ブラウザ簡易検証（サーバー側では未使用）
                                        placeholder="半角数字のみ"
                                        value={this.state.min_password_length}
                                        onChange={() => {}}
                                        onInput={this.handleInput.bind(this)}
                                        autoComplete="off"
                                        style={{
                                            width: '100%',
                                            height: '36px',
                                            padding: '6px 10px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '4px',
                                            fontSize: '14px',
                                            boxSizing: 'border-box',
                                        }}
                                    />
                                    {error && (
                                        <p
                                            id="minLengthError"
                                            className="error-text"
                                            style={{ marginTop: '6px', color: '#DC3545', fontSize: '12px' }}
                                            aria-live="polite"
                                        >
                                            {error}
                                        </p>
                                    )}
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="min-password-length">
                {/* ヘッダー */}
                <div className="header">
                    <div className="title">最低パスワード文字数設定</div>
                    <div className="operations"></div>
                </div>

                {/* 本文 */}
                <div className="min-password-length-area">
                    <div className="scroll">

                        {this.details()}

                        <div className="buttons">
                            <button
                                className="button-1"
                                type="button"
                                onClick={this.submit.bind(this)}
                            >
                                設定を保存
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MinPasswordLength.PropType = {
    handlers: PropTypes.object
};
